import { MessageDescriptor } from "react-intl";
import { ActionType, createAction } from "typesafe-actions";

export const handleError = createAction("@errors/handleError")<{
  defaultMessage?: MessageDescriptor;
  defaultMessageValues?: Record<string, string | undefined>;
  displayNotification?: boolean;
  error: unknown;
  messageByErrorCodeMap?: Record<string, MessageDescriptor>;
}>();

export type Actions = ActionType<typeof handleError>;
